(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dirath-quick-view"] && !Shopify.designMode) return;
  try {
    (function () {
  var modal, body;

  function fmtMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'Rs. ' + parts.join('.');
  }

  function closeModal() {
    if (modal) modal.hidden = true;
  }

  function renderProduct(product) {
    var image = (product.images && product.images[0]) || product.featured_image || '';
    var variants = product.variants || [];
    var firstAvailable = variants.filter(function (v) { return v.available; })[0] || variants[0];

    var sizesHtml = '';
    variants.forEach(function (v, i) {
      var label = v.option1 || v.title;
      var checked = firstAvailable && v.id === firstAvailable.id ? ' checked' : '';
      var disabled = v.available ? '' : ' disabled';
      sizesHtml +=
        '<input class="dirath-visually-hidden dirath-size__input" type="radio" name="id" id="qv-size-' + i + '" value="' + v.id + '" data-qv-price="' + v.price + '"' + checked + disabled + '>' +
        '<label class="dirath-size' + (v.available ? '' : ' dirath-size--unavailable') + '" for="qv-size-' + i + '">' + label + '</label>';
    });

    body.innerHTML =
      '<div class="dirath-qv__grid">' +
        '<img class="dirath-qv__img" src="' + image + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '">' +
        '<div>' +
          '<div class="dirath-eyebrow">Hand-tooled &middot; 32mm</div>' +
          '<h2 class="dirath-qv__title">' + product.title + '</h2>' +
          '<div class="dirath-qv__price" data-qv-price-display>' + fmtMoney(firstAvailable ? firstAvailable.price : product.price) + '</div>' +
          '<form action="/cart/add" method="post" class="dirath-qv__form" data-qv-form>' +
            (variants.length > 1 ? '<div class="dirath-qv__sizes" role="radiogroup" aria-label="Waist size">' + sizesHtml + '</div>' : '<input type="hidden" name="id" value="' + (firstAvailable ? firstAvailable.id : '') + '">') +
            '<button type="submit" name="add" class="dirath-btn dirath-btn--solid dirath-qv__add"' + (product.available ? '' : ' disabled') + '>' +
              (product.available ? 'Add to bag' : 'Sold out') +
            '</button>' +
          '</form>' +
          '<a class="dirath-textlink dirath-qv__link" href="' + product.url + '">View full details</a>' +
        '</div>' +
      '</div>';

    var priceDisplay = body.querySelector('[data-qv-price-display]');
    body.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var price = input.getAttribute('data-qv-price');
        if (price && priceDisplay) priceDisplay.textContent = fmtMoney(parseInt(price, 10));
      });
    });
  }

  function openQuickView(handle) {
    if (!modal) return;
    modal.hidden = false;
    body.innerHTML = '<div class="dirath-qv__loading">Loading&hellip;</div>';
    fetch('/products/' + handle + '.js')
      .then(function (res) { if (!res.ok) throw new Error('not found'); return res.json(); })
      .then(renderProduct)
      .catch(function () {
        body.innerHTML = '<div class="dirath-qv__error">Couldn\'t load this product. <a class="dirath-textlink" href="/products/' + handle + '">View it here</a> instead.</div>';
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (trigger) {
      e.preventDefault();
      openQuickView(trigger.getAttribute('data-quick-view'));
      return;
    }
    if (e.target.closest('[data-qv-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function boot() {
    modal = document.getElementById('dirath-qv');
    if (modal) body = modal.querySelector('[data-qv-body]');
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
  } catch(e) { console.error(e); }
})();

})();
